import { render, staticRenderFns } from "./JsonFormField.vue?vue&type=template&id=c15a43c4"
import script from "./JsonFormField.vue?vue&type=script&lang=js"
export * from "./JsonFormField.vue?vue&type=script&lang=js"
import style0 from "./JsonFormField.vue?vue&type=style&index=0&id=c15a43c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports